"use client";

import { c as _c } from "react/compiler-runtime";
import type React from "react";
import { useLayoutEffect } from "react";
const QUICK_VOTE_TRANSFORM_DATA_ATTRIBUTE = "quickVoteTransform";
const QUICK_VOTE_COMPUTED_STYLE_PATCH_FLAG = "__memesQuickVoteComputedStylePatched";
function patchComputedStyleForFallbackSwipe() {
  if (typeof globalThis.window.Touch === "function") {
    return;
  }
  const browserWindow = globalThis.window;
  const patchedWindow = browserWindow as typeof browserWindow & {
    [QUICK_VOTE_COMPUTED_STYLE_PATCH_FLAG]?: boolean;
  };
  if (patchedWindow[QUICK_VOTE_COMPUTED_STYLE_PATCH_FLAG]) {
    return;
  }
  const originalGetComputedStyle = browserWindow.getComputedStyle.bind(browserWindow);
  browserWindow.getComputedStyle = ((element: Element, pseudoElement?: string) => {
    const computedStyle = originalGetComputedStyle(element, pseudoElement);
    if (!(element instanceof HTMLElement)) {
      return computedStyle;
    }
    const transform = element.dataset[QUICK_VOTE_TRANSFORM_DATA_ATTRIBUTE] ?? "";
    if (transform.length === 0) {
      return computedStyle;
    }
    const patchedComputedStyle = Object.create(computedStyle) as CSSStyleDeclaration;
    Object.defineProperty(patchedComputedStyle, "transform", {
      configurable: true,
      value: transform
    });
    patchedComputedStyle.getPropertyValue = (property: string) => property === "transform" ? transform : computedStyle.getPropertyValue(property);
    return patchedComputedStyle;
  }) as typeof browserWindow.getComputedStyle;
  patchedWindow[QUICK_VOTE_COMPUTED_STYLE_PATCH_FLAG] = true;
}
export function usePatchComputedStyleForFallbackSwipe() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useLayoutEffect(_temp, t0);
}
function _temp() {
  patchComputedStyleForFallbackSwipe();
}
export function useSwipeCommitTimeoutCleanup(clearSwipeCommitTimeout) {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] !== clearSwipeCommitTimeout) {
    t0 = () => () => {
      clearSwipeCommitTimeout();
    };
    t1 = [clearSwipeCommitTimeout];
    $[0] = clearSwipeCommitTimeout;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useLayoutEffect(t0, t1);
}
export function useQuickVotePreviewCardTouchFallback(t0) {
  const $ = _c(9);
  const {
    canUseSwiperTouchSurface,
    handleTouchSurfaceCancel,
    handleTouchSurfaceEnd,
    handleTouchSurfaceMove,
    handleTouchSurfaceStart,
    isMobile,
    previewCardRef
  } = t0;
  let t1;
  let t2;
  if ($[0] !== canUseSwiperTouchSurface || $[1] !== handleTouchSurfaceCancel || $[2] !== handleTouchSurfaceEnd || $[3] !== handleTouchSurfaceMove || $[4] !== handleTouchSurfaceStart || $[5] !== isMobile || $[6] !== previewCardRef) {
    t1 = () => {
      if (canUseSwiperTouchSurface || !isMobile) {
        return;
      }
      const previewCardNode = previewCardRef.current;
      if (!previewCardNode) {
        return;
      }
      const handleTouchStart = event => {
        handleTouchSurfaceStart(event);
      };
      const handleTouchMove = event_0 => {
        handleTouchSurfaceMove(event_0);
      };
      const handleTouchEnd = event_1 => {
        handleTouchSurfaceEnd(event_1);
      };
      const handleTouchCancel = event_2 => {
        handleTouchSurfaceCancel(event_2);
      };
      previewCardNode.addEventListener("touchstart", handleTouchStart);
      previewCardNode.addEventListener("touchmove", handleTouchMove);
      previewCardNode.addEventListener("touchend", handleTouchEnd);
      previewCardNode.addEventListener("touchcancel", handleTouchCancel);
      return () => {
        previewCardNode.removeEventListener("touchstart", handleTouchStart);
        previewCardNode.removeEventListener("touchmove", handleTouchMove);
        previewCardNode.removeEventListener("touchend", handleTouchEnd);
        previewCardNode.removeEventListener("touchcancel", handleTouchCancel);
      };
    };
    t2 = [canUseSwiperTouchSurface, handleTouchSurfaceCancel, handleTouchSurfaceEnd, handleTouchSurfaceMove, handleTouchSurfaceStart, isMobile, previewCardRef];
    $[0] = canUseSwiperTouchSurface;
    $[1] = handleTouchSurfaceCancel;
    $[2] = handleTouchSurfaceEnd;
    $[3] = handleTouchSurfaceMove;
    $[4] = handleTouchSurfaceStart;
    $[5] = isMobile;
    $[6] = previewCardRef;
    $[7] = t1;
    $[8] = t2;
  } else {
    t1 = $[7];
    t2 = $[8];
  }
  useLayoutEffect(t1, t2);
}